import {
  formatVoiceLabel,
  getSpeakerKey,
  SpeakerColorEntry,
} from '@app/modules/diarization/speaker-utils';
import { SpeakerDisplay } from '@app/modules/persons/components/SpeakerDisplay';
import { Box } from '@mui/material';
import { memo } from 'react';
import { FormattedTranscriptionType } from './transcriptions.types';

export interface TranscriptionSpeakersCellProps {
  original: FormattedTranscriptionType;
  index: number;
  speakers: SpeakerColorEntry[] | undefined;
}

/**
 * Cell content for the speakers column: unique speakers with color and optional person avatar.
 */
function TranscriptionSpeakersCellComponent({
  original,
  index,
  speakers,
}: TranscriptionSpeakersCellProps) {
  const filteredData = original?.elastic_data?.diarization?.filter(
    (item, idx, self) =>
      self.findIndex((obj) => getSpeakerKey(obj ?? {}) === getSpeakerKey(item ?? {})) === idx,
  );

  return (
    <Box key={`speaker-${index}`} sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
      {filteredData?.map((data, idx) => {
        if (!data) {
          return null;
        }
        const speaker = speakers?.find((item) => item.key === getSpeakerKey(data));

        return (
          <SpeakerDisplay
            key={`speaker-${speaker?.key ?? idx}`}
            personId={data.person_id}
            fallbackLabel={formatVoiceLabel(data.voice_label)}
            color={speaker?.color}
          />
        );
      })}
    </Box>
  );
}

const TranscriptionSpeakersCell = memo(TranscriptionSpeakersCellComponent);
TranscriptionSpeakersCell.displayName = 'TranscriptionSpeakersCell';

export default TranscriptionSpeakersCell;
